import { DetailsCandidatureComponent } from './details-candidature.component';
import { AuthGuard } from '../../shared/_guards/auth.guard';

export const DETAILS_CANDIDATURE_ROUTE = [
  { path: 'candidatures/:id', component: DetailsCandidatureComponent, canActivate: [AuthGuard]},
  { path: 'candidats-manager/:id', component: DetailsCandidatureComponent, canActivate: [AuthGuard]},
]
